export enum ESubscriptionLevel {
  /** Бронзовый **/
  Bronze = 'bronze',
  /** Серебряный **/
  Silver = 'silver',
  /** Золотой **/
  Gold = 'gold',
  /** Платиновый **/
  Platinum = 'platinum',
}
